module.exports = __webpack_public_path__ + "static/media/21-mobile.0748169c.jpg";